import {
  DefaultEffects,
  IComboBox,
  IComboBoxOption,
  Panel,
  PanelType,
  TextField,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { PanelHeader } from "../../../components/Panel/PanelHeader";
import { PanelFooter } from "../../../components/Panel/PanelFooter";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { useEquipos } from "../../../hooks/Equipos/useEquipos";
import {
  IPostCrearEquipo,
  initialPostCrearEquipo,
} from "../../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { ComboBoxIDS } from "../../../components/generic/ComboBoxIDS";
import { useComboModelos } from "../../../hooks/combosHooks/useComboModelos";
interface IPanelAddEquipo {
  isOpen: boolean;
  onDismiss: () => void;
  onRefreshTable: () => void;
}
export const PanelAddEquipos = (props: IPanelAddEquipo) => {
  const [request, setRequest] = useState<IPostCrearEquipo>(
    initialPostCrearEquipo
  );
  const { postCrearEquipo, ocultarMensaje, response, isSend } = useEquipos();
  const {
    dataComboModelos,
    onClickComboModelos,
    _onkeyUpSearchDispositivo,
    comboBoxRefModelos,
  } = useComboModelos();

  const onRenderHeader = useCallback(
    () => (
      <>
        <PanelHeader
          nameIconHeader="add"
          textHeader={`Equipos MMG`}
          subTextHeader={`Agregar Equipos`}
        />
      </>
    ),
    []
  );
  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooter
          texto="Agregar"
          onClick={() => {
            postCrearEquipo(request);
          }}
          onDismiss={() => {
            props.onDismiss();
          }}
        />
      </>
    ),
    [postCrearEquipo, request]
  );

  const onChangeCombo = (
    event: React.FormEvent<IComboBox>,
    option?: IComboBoxOption
  ) => {
    if (event !== undefined) {
      if (option) {
        setRequest({ ...request, modeloId: option.key.toString() });
      }
    }
  };

  const onChangeTextField = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    if (newValue) {
      setRequest({ ...request, nombre: newValue });
    }
  };
  useEffect(() => {
    if (!props.isOpen) {
      ocultarMensaje();
      props.onRefreshTable();
      setRequest(initialPostCrearEquipo);
    }
  }, [props.isOpen]);

  return (
    <>
      <Panel
        type={PanelType.smallFixedFar}
        onRenderHeader={onRenderHeader}
        onRenderFooter={onRenderFooter}
        isFooterAtBottom
        isOpen={props.isOpen}
        onDismiss={props.onDismiss}
      >
        <>
          <MensajeBar response={response} ocultar={() => {}} />
          {isSend == true ? (
            <IdicadorProgress isSend={isSend} subText="Espere un momento..." />
          ) : (
            <div className="ms-Grid" dir="ltr">
              <div
                style={{
                  margin: "30px 0px",
                  width: "100%",
                  height: "auto",
                  padding: "15px 0px",
                }}
              >
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <ComboBoxIDS
                      title="Modelos de Equipos:"
                      componentRef={comboBoxRefModelos}
                      KeyUp={_onkeyUpSearchDispositivo}
                      onClick={onClickComboModelos}
                      options={dataComboModelos}
                      onChange={(e, option) => {
                        onChangeCombo(e, option);
                      }}
                    />
                  </div>
                </div>
                <div className="ms-Grid-row">
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                    <br />
                    <br />
                    <TextField
                      label="Nombre del Equipo:"
                      underlined
                      required
                      placeholder="Escribir aquí"
                      onChange={onChangeTextField}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      </Panel>
    </>
  );
};
